import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { FormValues } from '../../type';
import styles from './SymptomsField.module.scss';

interface SymptomsFieldProps {
  control: Control<FormValues>;
  name: "bothers_you";
}

const SymptomsField: React.FC<SymptomsFieldProps> = ({ control, name = "bothers_you" }) => {
  console.log(control, "control")
  return (
    <div className={styles.symptomsContainer}>
      <Controller
        name={name}
        control={control}
        rules={{
          required: 'Opisz swoje dolegliwości i objawy',
          minLength: {
            value: 1,
            message: 'Opis powinien mieć co najmniej 1 znaków'
          },
          maxLength: {
            value: 1000,
            message: 'Opis nie może przekraczać 1000 znaków'
          },
          validate: (value) => {
            if (!value.trim()) {
              return 'Opis nie może być pusty';
            }
            return true;
          }
        }}
        render={({ field, fieldState }) => (
          <div>
            <textarea
              {...field}
              className={`${styles.textarea} ${fieldState.error ? styles.error : ''}`}
              placeholder="Np. bezsenność, bóle kręgosłupa, bóle głowy"
              rows={4}
            />
            <div className={styles.fieldFooter}>
              {fieldState.error && (
                <span className={styles.errorMessage}>
                  {fieldState.error.message}
                </span>
              )}
             
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default SymptomsField; 